import QrcodeBlock from './QrcodeBlock';

export default QrcodeBlock;
